module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1CRXHIs/tc-custom/9781460324851.jpg?1697114358197",
      "alt": "This image is the cover for the book Wedding for Christmas"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Wedding for Christmas\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Just how committed is he?")]), _c('br'), _c('br'), _vm._v("There is nothing Christina Roman loves more than being a mom. Although working as the chef at her family's inn, Ladera by the Sea, is a close second. And a quickly rising third is Shane McCallister, the local contractor. After her husband's tragic soldier's death, Cris thought she would never be able to move on. But with the way Shane bonds with her five-year-old son, she might be persuaded. Except then her in-laws sue her for custody of Ricky. Now facing every mother's worst nightmare, she'll do anything not to lose her child, and Shane is determined to help. Could her sister's Christmas wedding be their inspiration?\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Marie Ferrarella\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("This USA TODAY bestselling and RITA ® Award-winning author has written more than two hundred books for Harlequin Books and Silhouette Books, some under the name Marie Nicole. Her romances are beloved by fans worldwide. Visit her website at www.marieferrarella.com.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0